import styles from './index.module.scss';

export default function BorderedCard({children, className}) {
  return (
    <div className={`${styles.borderedCard} ${className ? className : ''}`}>
      {children}
    </div>
  );
}
